module.exports = __webpack_public_path__ + "static/soc2-17851990f8204ed92eb8cdb2d5e8da73.svg";